import { render, staticRenderFns } from "./freestallVentilation.vue?vue&type=template&id=fd352b14&"
import script from "./freestallVentilation.vue?vue&type=script&lang=js&"
export * from "./freestallVentilation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports